var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.componentKey,staticClass:"container v-content-container tooltip-wrapper"},[_c('div',{staticClass:"row tooltip-wrapper"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',[_c('i',{staticClass:"fa fa-user fa-fw fa-lg"}),_vm._v(" "+_vm._s(_vm.$label("customer.participants", "Participants"))+" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.$label('customer.new_participant', 'New participant'),
            classes: 'custom-tooltip'
          }),expression:"{\n            content: $label('customer.new_participant', 'New participant'),\n            classes: 'custom-tooltip'\n          }"}],staticClass:"btn btn-v-lightgreen-white pull-right",attrs:{"to":{ name: 'NewCustomerParticipant' }}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-plus"})])],1)])]),_c('input',{attrs:{"type":"hidden","id":"customer-display-all","value":"false"}}),_c('navigation-tabs',{attrs:{"customer-id":_vm.selectedCustomerId}}),_vm._m(0),(_vm.noDataExist)?_c('error404'):[_c('alert-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.failedRequest),expression:"failedRequest"}],staticClass:"mt-8",attrs:{"type":"warning","closeable":false,"show-icon":false}},[_vm._v(" "+_vm._s(_vm.$label( "customer.participants_failed_request", "Request failed while loading participants." ))+" ")]),_c('Table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.failedRequest),expression:"!failedRequest"}],attrs:{"id":"participants-table","loading":_vm.loading,"columns":[
        {
          title: 'Name',
          id: function (row) { return ("participant-name-" + (row.id)); },
          value: function (row) { return _vm.beautifyName(row.first_name, row.last_name); },
          onClick: function (row) { return _vm.$router.push({
              name: 'CustomerParticipantDetails',
              params: {
                customer_id: _vm.selectedCustomerId,
                participant_id: row.id
              }
            }); },
          tooltip: function () { return '<div class="tooltip-title-background"><p class="tooltip-title"><i class="text-primary fa fa-lg fa-fw fa-info-circle"></i><b>' +
            _vm.$label('common.groups', 'Groups') +
            '</b></p></div>' +
            '<p class="tooltip-content">' +
            _vm.$label(
              'customer.no_assignment_existing',
              'No assignment existing'
            ) +
            '</p>'; }
        },
        {
          title: 'Email',
          field: 'email',
          id: function (row) { return ("participant-email-" + (row.id)); }
        },
        {
          title: 'Gender',
          id: function (row) { return ("participant-gender-" + (row.id)); },
          value: function (row) { return row.gender === 0 ? 'Gender' : row.gender === 1 ? 'Female' : 'Male'; }
        },
        {
          title: 'Birth date',
          field: 'birthdate',
          id: function (row) { return ("participant-birthdate-" + (row.id)); }
        }
      ],"actions":[
        {
          type: 'detail',
          onClick: function (row) {
            _vm.$router.push({
              name: 'CustomerParticipantDetails',
              params: {
                customer_id: _vm.selectedCustomerId,
                participant_id: row.id
              }
            });
          }
        },
        {
          type: 'delete',
          id: function (row) { return ("delete-participant-button-" + (row.id)); },
          onClick: function (row) { return _vm.deleteCustomerParticipant(row.id); }
        }
      ],"selectable":"","data":_vm.participants,"meta":_vm.metaData},on:{"fetchQuery":function (params) {
          _vm.fetchParams = params;
          _vm.getCustomerParticipants({
            //
          });
        }}},[_c('div',{staticClass:"btn-group",attrs:{"id":"action-dropdown"}},[_c('button',{staticClass:"btn btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "+_vm._s(_vm.$label("common.actions", "Actions"))+" "),_c('span',{staticClass:"caret"})]),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'NewCustomerParticipant' }}},[_c('i',{staticClass:"text-primary fa fa-fw fa-lg fa-plus"}),_vm._v(" "+_vm._s(_vm.$label( "customer.new_participant_long", "Create new participant" )))])],1)])])]),_c('div',{staticClass:"row mb-8"},[_c('div',{staticClass:"col-xs-12"})])]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-8"},[_c('div',{staticClass:"col-xs-12"})])}]

export { render, staticRenderFns }